export const LOG_LEVEL = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};
export const DEFAULT_LOG_LEVEL = LOG_LEVEL.INFO;
/** Higher is more severe; a logger writes lines at or above its own level. */
export const LOG_LEVEL_PRIORITY = {
    [LOG_LEVEL.DEBUG]: 10,
    [LOG_LEVEL.INFO]: 20,
    [LOG_LEVEL.WARN]: 30,
    [LOG_LEVEL.ERROR]: 40,
};
/** Context keys whose values are never written, wherever they appear. */
export const REDACTED_CONTEXT_KEYS = ['password', 'accessToken', 'refreshToken', 'authorization'];
export const REDACTED_PLACEHOLDER = '[Redacted]';
